import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Theme } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import ConfirmationDialog from '../../../components/ConfirmationDialog';
import { LessonLocation, SwimmingLessonProvider } from '../../../types';
import SwimmingLessonProviderRepository from '../repository/SwimmingLessonProviderRepository';
import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../config/theme';

const useStyles = makeStyles((theme: Theme) => ({
  deactivateIcon: {
    padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    backgroundColor: colors.softPeachDark,
    '&:hover': {
      backgroundColor: colors.softPeach,
    },
  },
}));

interface DeactivateLessonLocationButtonProps {
  swimmingLessonProvider: SwimmingLessonProvider;
  lessonLocation: LessonLocation;
  onSuccess: () => void;
}

const DeactivateLessonLocationButton = (
  props: DeactivateLessonLocationButtonProps,
) => {
  const classes = useStyles();
  const notifications = useSnackbar();

  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    useState<boolean>(false);

  const openConfirmationDialog = () => {
    setConfirmationDialogOpen(true);
  };

  const closeConfirmationDialog = () => {
    setConfirmationDialogOpen(false);
  };

  const deactivateLessonLocation = () => {
    new SwimmingLessonProviderRepository()
      .deactivateLessonLocation(
        props.swimmingLessonProvider.id,
        props.lessonLocation.id,
      )
      .then(() => {
        notifications.enqueueSnackbar(
          'De leslocatie is succesvol gedeactiveerd',
          {
            variant: 'success',
          },
        );
        props.onSuccess();
      })
      .catch(() => {
        notifications.enqueueSnackbar(
          'Er is iets fout gegaan bij het deactiveren van de leslocatie',
          {
            variant: 'error',
          },
        );
      })
      .finally(() => closeConfirmationDialog());
  };

  return (
    <>
      <IconButton
        size="small"
        className={classes.deactivateIcon}
        onClick={() => openConfirmationDialog()}
      >
        <FontAwesomeIcon icon={['fal', 'times']} />
      </IconButton>
      <ConfirmationDialog
        title="Deactiveren"
        query="Weet je zeker dat je deze leslocatie wilt deactiveren?"
        buttonText="Bevestigen"
        isOpen={confirmationDialogOpen}
        onClose={closeConfirmationDialog}
        onConfirm={() => deactivateLessonLocation()}
      />
    </>
  );
};

export default DeactivateLessonLocationButton;
